import axios from "axios";
import localStorageService from "app/services/localStorageService";
import Moment from "moment";
import br from "date-fns/locale/pt-BR";
import { registerLocale } from "react-datepicker";

registerLocale("pt-BR", br);

export const Get = (dt) => {
  return new Promise((resolve) => {
    const auth = localStorageService.getItem("auth_user");
    const dtChamada = Moment(dt).format("YYYY-MM-DD");

    if (auth === null) {
      resolve({ status: 403, data: [] });
    } else {
      axios
        .get(`/api/chamada/${auth.idEscola}/${dtChamada}`)
        .then((retorno) => resolve(retorno))
        .catch(() => resolve({ status: 403, data: [] }));
    }
  });
};

export const Save = (props) =>
  new Promise((resolve) => {
    const { idAluno, dtChamada, idPresenca, txObservacao } = props;
    const newDtChamada = Moment(dtChamada).format("YYYY-MM-DD HH:mm:ss");
    const auth = localStorageService.getItem("auth_user");
    const url = `/api/chamada`;

    const modelo = {
      idEscola: auth.idEscola,
      idAluno,
      dtChamada: newDtChamada,
      idPresenca,
      idSms: 0,
      txObservacao,
    };

    axios.post(url, modelo).then(function (data) {
      resolve(data);
    });
  });
